/* =============================
AKE (zxw) Catalog (Standard)
Auto-generated from config
Pattern: unified
============================= */
(function () {
const API_SOURCES = {
'zxw': {
name: 'zxw',
url: 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/ake-multi-proxy?source=zxw',
enabled: true,
priority: 1,
idPrefix: '',
prefixes: [],
unwanted: new Set(['亚服','欧美','男角色','女角色','美欧','SEA','Asia','Global','America','Europe','HMT']),
nameKey: 'name',
idKey: 'id',
imageKey: 'img',
root: 'results',
extra_data: {"level":{"field":"source","regex":"等级[:：]([0-9]+)"},"gender":{"field":"deck_info","mapping":{"女":"Female","男":"Male"}},"server":{"field":"deck_info","mapping":"servers"}}
}
};

const ZXW_BASE = 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/ake-multi-proxy?source=zxw';

let selected = {}; /* Keyed by Display Name */

/* Lazy Loading State */
let allSearchResults = [];
let renderedCount = 0;
const BATCH_SIZE = 24;
let resultObserver = null;

/* ====== Dynamic Partials Inclusion ====== */
/* SCROLL LOGIC */
const initResultObserver = () => {
if (resultObserver) resultObserver.disconnect();
resultObserver = new IntersectionObserver((entries) => {
if (entries[0].isIntersecting && renderedCount < allSearchResults.length) { renderBatch(); } }, { rootMargin: '200px'
    }); };
/* UI UPDATES */
const updateSelectedUI = () => {
const totalCount = Object.values(selected).reduce((sum, sel) => sum + (sel.count || 0), 0);
const el = document.querySelector("#selectedCount");
if (el) el.textContent = totalCount;
};

const scrollToResults = () => {
document.querySelector("#results")?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const updateThumbDisplay = (thumb, key) => {
const count = selected[key]?.count || 0;
const existingBadge = thumb.querySelector('.count-badge');
if (count > 0) {
thumb.classList.add('selected');
if (existingBadge) existingBadge.textContent = count;
else {
const b = document.createElement('div');
b.className = 'count-badge';
b.textContent = count;
thumb.querySelector('.thumb-img-container').appendChild(b);
}
} else {
thumb.classList.remove('selected');
if (existingBadge) existingBadge.remove();
}
};
/* CLIPBOARD */
const showToast = () => {
const toast = document.querySelector("#toast");
if (!toast) return;
toast.classList.remove('hidden', 'show');
toast.offsetHeight;
toast.classList.add('show');
setTimeout(() => {
toast.classList.remove('show');
setTimeout(() => toast.classList.add('hidden'), 300);
}, 3000);
};

const copyToClipboard = text => {
if (navigator.clipboard) {
navigator.clipboard.writeText(text).then(showToast).catch(() => fallbackCopy(text));
} else fallbackCopy(text);
};

const fallbackCopy = text => {
const ta = document.createElement('textarea');
ta.value = text;
ta.style.cssText = 'position:fixed;left:-9999px';
document.body.appendChild(ta);
ta.select();
try {
document.execCommand('copy');
showToast();
} catch (e) { }
document.body.removeChild(ta);
};
/* HELPERS */
/* HELPERS */
const escapeHtml = s => String(s || '').replace(/[&<>"]|'/g, m => ({
    '&': '&amp;',
    '<': '&lt;' , '>' : '&gt;' , '"' : '&quot;' , "'" : '&#39;' }[m])); const normalizeString=(name, prefixes)=> {
        if (!name) return '';
        let n = String(name).trim();
        if (prefixes) prefixes.forEach(p => { if (n.startsWith(p)) n = n.slice(p.length); });
        return n;
        };

        const getResultsArray = (payload, apiId) => {
        if (!payload) return [];
        if (Array.isArray(payload)) return payload;

        const config = API_SOURCES[apiId];
        /* Try mapping root first */
        if (config && config.root) {
        const parts = config.root.split('.');
        let cur = payload;
        for (const p of parts) if (cur) cur = cur[p];
        if (Array.isArray(cur)) return cur;
        }

        /* Try common patterns (including robustness fix from ZXW) */
        return payload.results || payload.items || payload.data?.items || payload.data?.records || payload.data ||
        (Array.isArray(payload.c) ? payload.c : []);
        };

        const buildHasMap = (acc) => {
        let has = {};
        if (acc.deck_info) {
        try {
        has = typeof acc.deck_info === 'string' ? JSON.parse(acc.deck_info) : acc.deck_info;
        } catch (e) { }
        } else if (acc.items) {
        acc.items.forEach(it => { has[it.name] = (has[it.name] || 0) + (it.count || 1); });
        } else if (acc.cardList && Array.isArray(acc.cardList)) {
        acc.cardList.forEach(c => {
        const name = c.cardName || 'Unknown';
        has[name] = (has[name] || 0) + 1;
        });
        }
        return has;
        };

        const accountMatchesSelection = (has, selectedKeys) => {
        return selectedKeys.every(k => {
        const req = selected[k];
        return req.rawNames.some(rn => (has[rn] || 0) >= req.count);
        });
        };
/* SETTINGS */
/*======Settings & API Registry======*/
let appSettings = { translations_json: '{}', images_json: '{}', api_toggles: {}, api_priority: {} };
const logger = {
log: (...args) => { if (appSettings.enable_debug) console.log(...args); },
warn: (...args) => { if (appSettings.enable_debug) console.warn(...args); },
error: (...args) => { console.error(...args); } /* Errors always show */
};

try {
const el = document.getElementById('catalog-settings-zxw-ake');
if (el) appSettings = JSON.parse(el.textContent);

if (appSettings.api_toggles) {
Object.keys(API_SOURCES).forEach(apiId => {
if (appSettings.api_toggles.hasOwnProperty(apiId)) {
API_SOURCES[apiId].enabled = appSettings.api_toggles[apiId] === true;
}
if (appSettings.api_names && appSettings.api_names[apiId]) {
API_SOURCES[apiId].name = appSettings.api_names[apiId];
}
if (appSettings.api_priority && appSettings.api_priority.hasOwnProperty(apiId)) {
API_SOURCES[apiId].priority = parseInt(appSettings.api_priority[apiId], 10);
}
});
}
} catch (e) { }
/* TRANSLATIONS */
/*======Translations & Images======*/
let nameTranslationsMap = {};
try {
const json = JSON.parse(appSettings.translations_json || '{}');
Object.entries(json).forEach(([key, val]) => {
const standardValue = typeof val === 'string' ? val.trim() : val;
key.split('|').forEach(k => {
if (k.trim()) nameTranslationsMap[k.trim()] = standardValue;
});
});
} catch (e) { }

let customImagesMap = {};
try {
const json = JSON.parse(appSettings.images_json || '{}');
Object.entries(json).forEach(([key, val]) => {
const imageUrl = typeof val === 'string' ? val.trim() : val;
key.split('|').forEach(k => {
if (k.trim()) customImagesMap[k.trim()] = imageUrl;
});
});
} catch (e) { }

const translateName = name => nameTranslationsMap[name] || name;
const getCustomImage = name => customImagesMap[name] || null;
/* ID HANDLER */
/*======ID Transformation======*/
function privateToPublicID(privateID, source) {
    if (!privateID) return '';
    const srcConf = API_SOURCES[source];
    const prefix = srcConf?.name ? srcConf.name.replace(/\s+/g, '') : 'ACC';
    return GachaUtils.obfuscateId(privateID, prefix);
}

function publicToPrivateID(publicID) {
    if (!publicID) return '';
    let core = publicID.trim();
    if (core.includes('----')) {
        core = core.split('----')[0];
    }
    if (core.includes('-')) {
        core = core.split('-')[1];
    } else if (core.length > 5 && (core.startsWith('WW') || core.length > 12)) {
        if (core.length >= 5) core = core.substring(2, core.length - 2);
    }
    let chars = core.split('');
    for (let i = 0; i + 1 < chars.length; i += 2) {
        const t = chars[i];
        chars[i] = chars[i + 1];
        chars[i + 1] = t;
    }
    return chars.reverse().join('');
}



/* CATALOG SPECIFIC RESOURCE FETCHER */
const loadResources = () => {
logger.log('🚀 [ZXW] Loading resources...');
const resourcePromises = [];

if (API_SOURCES['zxw'].enabled) {
logger.log('🔵 [ZXW-INIT] API Source: zxw | Type: post | Priority: 1');
const baseUrl = ZXW_BASE;
const params = [];
params.push('action=' + encodeURIComponent('resource'));
const url = baseUrl + (baseUrl.includes('?') ? '&' : '?') + params.join('&');

logger.log('📡 [ZXW] Fetching zxw resources:', url);
// Proxy handles the POST to target, so we just call the proxy (it can be GET or POST)
resourcePromises.push(
fetch(url)
.then(r => r.json())
.catch(err => {
logger.warn('⚠️ [ZXW] zxw fetch failed:', err);
return null;
})
);
} else {
resourcePromises.push(Promise.resolve(null));
}



/* CATALOG SPECIFIC SERVER MAPPER */
Promise.all(resourcePromises).then(results => {
logger.log('✅ [ZXW] All network requests complete.');
let resultIdx = 0;
const apiData = {};

{
const raw = results[resultIdx++];
logger.log('📦 [ZXW] Processing zxw data:', raw);

// ZXW Proxy returns the array directly, while others might wrap in data.records
const dataArray = Array.isArray(raw) ? raw : ((raw && raw.data && raw.data.records) ? raw.data.records : []);
apiData['zxw'] = dataArray;
logger.log('🟢 [ZXW-LOAD] Items loaded:', dataArray.length, '| Output Type: JSON Array');
logger.log('📊 [ZXW] zxw items:', dataArray.length);

const sMap = {};
sMap['Asia'] = 'A01';
sMap['Global'] = 'A02';
window._zxwServerMap = sMap;
}



/* CATALOG SPECIFIC REGISTRY MERGER */
const merged = {};
if (apiData['zxw'] && apiData['zxw'].length > 0) {
logger.log('🖇️ [ZXW] Merging zxw into registry...');
const prefixes = API_SOURCES['zxw'].prefixes;
const unwanted = API_SOURCES['zxw'].unwanted;

apiData['zxw'].forEach(item => {
const rawName = item.cardName || item.name;
const norm = normalizeString(rawName, prefixes);

const itemId = String(item.shortName || item.id || item.id || '');
const itemType = item.type || (itemId.startsWith('A') ? 'server' : (itemId.startsWith('W') ? 'weapon' : 'character'));

if (itemType === 'server') return;
if (unwanted.has(norm)) return;

const displayLabel = translateName(norm);
let itemImg = item.cardPicture || item.img || item.img_url;

if (!merged[displayLabel]) {
merged[displayLabel] = {
displayLabel: displayLabel,
normName: norm,
rawNames: new Set([rawName, norm, displayLabel]),
_zxw_id: itemId,
img: itemImg
};
} else {
merged[displayLabel]._zxw_id = itemId;
if(!merged[displayLabel].img) merged[displayLabel].img = itemImg;
merged[displayLabel].rawNames.add(rawName);
merged[displayLabel].rawNames.add(norm);
}
});
}

let allItems = Object.values(merged);
const orderSource = appSettings.character_order_source;
if (orderSource && apiData[orderSource]) {
// Standard sorting logic...
}

logger.log('🎨 [ZXW] Rendering', allItems.length, 'total unique characters.');
window._characterImageMap = {};
allItems.forEach(it => {
if (it.img) window._characterImageMap[it.displayLabel] = it.img;
});
renderFilters(allItems);
}).catch(e => {
console.error('❌ [ZXW] Critical merge error:', e);
document.querySelector("#filters").innerHTML = 'Failed to load character list.';
});
};


/* CATALOG SPECIFIC FILTER RENDERER */
const renderFilters = (items) => {
const container = document.querySelector("#filters");
if (!container) return;
container.innerHTML = "";

items.forEach(it => {
const thumb = document.createElement("div");
thumb.className = "thumb";

thumb.dataset.zxwId = it._zxw_id || '';
thumb.dataset.displayLabel = it.displayLabel;

thumb.innerHTML = `
<div class="thumb-img-container">
    <img src="${it.img || ''}" alt="${it.displayLabel}" loading="lazy" />
</div>
<div class="label">${it.displayLabel}</div>
`;

thumb.onclick = () => {
const key = thumb.dataset.displayLabel;
if (selected[key]) {
selected[key].count++;
} else {
selected[key] = {
count: 1,
zxwId: thumb.dataset.zxwId,
rawNames: Array.from(it.rawNames || [it.displayLabel])
};
}
logger.log('🖱️ [ZXW-CLICK] Card Selected:', key, '| ID:', thumb.dataset.zxwId, '| Current Count:',
selected[key].count);
logger.log('⚙️ [ZXW-BG] Triggering updateSelectedUI & updateThumbDisplay');
updateThumbDisplay(thumb, key);
updateSelectedUI();
};

thumb.oncontextmenu = (e) => {
e.preventDefault();
const key = thumb.dataset.displayLabel;
if (selected[key]) {
selected[key].count = Math.max(0, selected[key].count - 1);
if (selected[key].count === 0) delete selected[key];
logger.log('🖱️ [ZXW-CLICK] Card Deselected:', key, '| ID:', thumb.dataset.zxwId, '| Current Count:', selected[key] ?
selected[key].count : 0);
logger.log('⚙️ [ZXW-BG] Triggering updateSelectedUI & updateThumbDisplay');
updateThumbDisplay(thumb, key);
updateSelectedUI();
}
};

container.appendChild(thumb);
});
};


/* CATALOG SPECIFIC SEARCH LOGIC */
const performSearch = () => {
logger.log('🚀 [ZXW-SEARCH] performSearch() triggered. Validating inputs...');
const selectedKeys = Object.keys(selected).filter(k => selected[k].count > 0);
const serverSelect = document.querySelector("#serverSelect");
const server = serverSelect ? serverSelect.value : '';
const deckInput = document.querySelector("#deckInput")?.value.trim();

// Check if we have anything to search with (Characters, Server, or Deck ID)
const sid = window._zxwServerMap?.[server];

if (!selectedKeys.length && !deckInput && !sid) {
logger.warn("Please select characters or a specific server to search.");
return;
}

const res = document.querySelector("#results");
res.innerHTML = `<div class="no-data">Searching...</div>`;
scrollToResults();

const promises = [];

if (API_SOURCES['zxw'].enabled) {
let ids = [];

// Add Server ID if selected
if (sid) ids.push(sid);

// Add Character IDs
selectedKeys.forEach(k => {
const cid = selected[k].zxwId;
if (cid) {
for (let i = 0; i < selected[k].count; i++) { ids.push(cid); } } }); if (ids.length> 0) {
    logger.log('📦 [ZXW-SEARCH] Search Payload Constructed | Server ID:', sid, '| Selected Character IDs:', ids);
    const url = ZXW_BASE
    + (ZXW_BASE.includes('?') ? '&' : '?')
    + 'action=search&key=' + encodeURIComponent(ids.join(','));

    logger.log('🔍 [ZXW] Performing search for zxw:', url);
    promises.push(
    fetch(url)
    .then(r => {
    logger.log('✅ [ZXW-SEARCH] fetch() successful. Handing over to displayResults().');
    return r.json();
    })
    .catch(err => {
    logger.error('❌ [ZXW] zxw search failed:', err);
    return { results: [] };
    })
    );
    } else {
    promises.push(Promise.resolve({ results: [] }));
    }
    } else {
    promises.push(Promise.resolve({ results: [] }));
    }

    Promise.all(promises).then(results => {
    const all = [];
    results.forEach((r, i) => {
    const apiId = Object.keys(API_SOURCES)[i];
    const records = (r && r.results) ? r.results : [];
    records.forEach(item => {
    all.push({ ...item, _source: apiId });
    });
    });
    displayResults(all);
    });
    };


/* CATALOG SPECIFIC RESULT CONTROLLER */
/* ====== Sorting Logic ====== */
const calculateAccountTotal = (item) => {
let total = 0;
if (item.cardList && Array.isArray(item.cardList)) {
total = item.cardList.length;
}
return total;
};

const sortResults = () => {
const sortMode = document.getElementById('sortSelect')?.value || 'default';
if(sortMode === 'default') {
allSearchResults.sort((a, b) => (a._p || 0) - (b._p || 0));
} else {
allSearchResults.sort((a, b) => {
const totalA = calculateAccountTotal(a);
const totalB = calculateAccountTotal(b);
if (sortMode === 'count_desc') return totalB - totalA;
if (sortMode === 'count_asc') return totalA - totalB;
return 0;
});
}

/* Reset rendering */
renderedCount = 0;
const res = document.querySelector("#results");
if (res) res.innerHTML = '';
renderBatch();
};
const displayResults = (results) => {
allSearchResults = results;
renderedCount = 0;
const res = document.querySelector("#results");
if (!res) return;
res.innerHTML = "";

if (results.length === 0) {
res.innerHTML = '<div class="no-data">No accounts found matching your selection.</div>';
return;
}

initResultObserver();
renderBatch();
};

const renderBatch = () => {
const res = document.querySelector("#results");
if (!res) return;

const nextBatch = allSearchResults.slice(renderedCount, renderedCount + BATCH_SIZE);

nextBatch.forEach(item => {
const card = document.createElement("div");
card.className = "result-card";

// 1. Resolve ID (Apply Obfuscation)
const rawId = item.id || item.account || "N/A";
const displayId = rawId !== "N/A" ? privateToPublicID(rawId, 'zxw') : "N/A";

// 2. Resolve Server
let serverName = item.server || "Global";
if (item.cards && typeof item.cards === 'string') {
if (item.cards.includes('A01')) serverName = 'Asia';
else if (item.cards.includes('A02')) serverName = 'Global';
}

// 3. Resolve Items Data for Extended ID
const charNames = (item.cardList || []).map(c => c.cardName || 'Unknown');
const charString = charNames.join(',');
const extendedId = `${displayId}----${serverName}----[${charString}]`;

// 4. Resolve Items Grid HTML
const serverCards = ['亚服', '国际服', '美服', '欧服', '日服'];
const filteredCardList = (item.cardList || []).filter(c => !serverCards.includes(c.cardName));

const charHTML = filteredCardList.map(c => {
const name = c.cardName || 'Unknown';
return `
<div class="char">
    <div class="char-img-container">
        <img src="${c.cardPicture || ''}" alt="${name}" title="${name}" loading="lazy" />
    </div>
    <div class="cname">${name}</div>
</div>
`;
}).join('');

const sourceLabel = item._source ? item._source.toUpperCase() : 'ZXW';

card.innerHTML = `
<div class="result-header">
    <div>Account ID: <strong>${escapeHtml(displayId)}</strong></div>
    <div class="header-btns">
        <button class="copy-btn">Copy ID</button>
        <button class="price-btn">Price Check</button>
    </div>
</div>
<div class="result-info">
    <span>Server: ${serverName}</span> | <span>Source: ${sourceLabel}</span>
</div>
<div class="chars-row">
    ${charHTML}
</div>
`;

// Add event listeners (Consistency with Naonao)
card.querySelector('.copy-btn').onclick = () => copyToClipboard(extendedId);
card.querySelector('.price-btn').onclick = () => showPriceCheck(displayId, extendedId);

res.appendChild(card);
});

renderedCount += nextBatch.length;
if (renderedCount < allSearchResults.length) { const lastCard=res.lastElementChild; if (lastCard)
    resultObserver.observe(lastCard); } };

/* PRICE MODAL */
const initPriceModal = () => {
const modal = document.createElement('div');
modal.id = 'priceCheckModal';
modal.className = 'modal-backdrop hidden';
modal.innerHTML = `
<div class="modal-content">
    <div class="modal-header">
        <h3>Price Check Inquiry</h3>
        <button class="close-modal">&times;</button>
    </div>
    <div class="modal-body">
        <p class="step-header">Step 1: Copy Account ID</p>
        <div class="id-display-box highlighted">
            <span>Account ID:</span>
            <code id="modalAccountId">---</code>
            <input type="hidden" id="modalFullId" value="">
            <button class="copy-mini-btn" id="modalCopyBtn">Copy</button>
        </div>

        <div class="modal-divider"></div>

        <p class="step-header">Step 2: Choose Contact Method For Price Quotation</p>

        <div class="contact-row">
            <div class="contact-option primary">
                <div class="opt-icon">✨</div>
                <div class="opt-details">
                    <strong>Direct Message</strong>
                    <a href="https://discord.com/users/477359052662243349" target="_blank" class="modal-btn">DM
                        Admin</a>
                </div>
            </div>

            <div class="contact-option secondary">
                <div class="opt-icon">🌸</div>
                <div class="opt-details">
                    <strong>Join Server</strong>
                    <a href="https://discord.com/invite/exvg8GR8sk" target="_blank" class="modal-btn">Join &
                        DM CL</a>
                </div>
            </div>
        </div>
        <p class="modal-hint"
            style="text-align:center; margin-top:8px; font-size:0.8em; color:var(--text-muted); opacity:0.8;">
            (Discord Tag: <code>gachamacha2025</code>)
        </p>
    </div>
</div>
`;
document.body.appendChild(modal);

const closeBtn = modal.querySelector('.close-modal');
closeBtn.onclick = () => modal.classList.add('hidden');
modal.onclick = (e) => {
if (e.target === modal) modal.classList.add('hidden');
};

const cpBtn = modal.querySelector('#modalCopyBtn');
cpBtn.onclick = () => {
const fullId = document.querySelector('#modalFullId').value;
copyToClipboard(fullId);
cpBtn.textContent = 'Copied!';
setTimeout(() => cpBtn.textContent = 'Copy', 2000);
};
};

window.showPriceCheck = (id, fullId) => {
const modal = document.querySelector("#priceCheckModal");
if (!modal) return;
document.querySelector("#modalAccountId").textContent = id;
document.querySelector("#modalFullId").value = fullId || id;
modal.classList.remove('hidden');
};


/* INIT HANDLERS */
const sBtn = document.querySelector("#searchBtn");
if (sBtn) sBtn.onclick = performSearch;

const sortSel = document.querySelector("#sortSelect");
if (sortSel) sortSel.onchange = sortResults;

const cBtn = document.querySelector("#clearBtn");
if (cBtn) cBtn.onclick = () => {
selected = {};
document.querySelectorAll('.thumb').forEach(t =>
{t.classList.remove('selected'); t.querySelector('.count-badge')?.remove(); });
const idIn = document.querySelector("#idSearchInput");
if (idIn) idIn.value = '';
updateSelectedUI();
document.querySelector("#results").innerHTML = '';
};
window.copyToClipboard = copyToClipboard;
initPriceModal();
loadResources();

})();